import { render, staticRenderFns } from "./PruningWorkflowForm.vue?vue&type=template&id=368aa87d&scoped=true&lang=html&"
import script from "./PruningWorkflowForm.vue?vue&type=script&lang=js&"
export * from "./PruningWorkflowForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368aa87d",
  null
  
)

export default component.exports